import { CommonModule } from '@angular/common';
import { Component, computed, inject, OnInit } from '@angular/core';
import {
  IsActiveMatchOptions,
  RouterLink,
  RouterLinkActive,
} from '@angular/router';
import { LogicalGrowthComponentsModule } from '@app/logical-growth-components/logical-growth-components.module';
import { SidebarOption } from '@utils/interfaces/sidebar.interface';
import { SideBarService } from '@shared/UI/elements-ui/sidebar/sidebar.service';
import { IfPermissionsDirective } from '@shared/directives/if-permissions.directive';
import { SessionService } from '@utils/services/session.service';
import { resolveUserProfile } from '@utils/user-profile.util';

@Component({
  selector: 'sidebar',
  standalone: true,
  imports: [
    CommonModule,
    RouterLink,
    RouterLinkActive,
    IfPermissionsDirective,
    LogicalGrowthComponentsModule,
  ],
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SideBarComponent implements OnInit {
  private readonly _sessionService = inject(SessionService);
  public readonly sidebarController = inject(SideBarService);

  public sidebarOptions: SidebarOption[] = [];
  public readonly isOpen = this.sidebarController.isOpen;
  public readonly userProfile = computed(() =>
    resolveUserProfile(this._sessionService.user),
  );
  public readonly activeLinkOptions: IsActiveMatchOptions = {
    paths: 'subset',
    queryParams: 'subset',
    matrixParams: 'ignored',
    fragment: 'ignored',
  };

  ngOnInit(): void {
    this._deleteSubOptions();
  }

  public onOpenChange(isOpen: boolean): void {
    if (!isOpen) {
      this.closeSidebar();
    }
  }

  public toggleSection(sectionId: string, event: Event): void {
    event.preventDefault();
    this.sidebarController.toggleSection(sectionId);
  }

  public isSectionOpen(sectionId: string): boolean {
    return this.sidebarController.openSection() === sectionId;
  }

  public iconUrl(icon: string): string {
    return `url(assets/img/tabler/${icon}.svg)`;
  }

  public navigate(): void {
    this.closeSidebar();
    this.sidebarController.clearOptions();
  }

  public closeSidebar(): void {
    this.sidebarController.setClosed();
  }

  private _deleteSubOptions(): void {
    if (this._sessionService.user?.type === 'admin') {
      this.sidebarOptions = this.sidebarController.deleteSubOption(
        this.sidebarController.sidebarOptions(),
        ['collection-process', 'notifications'],
        ['my-collection-processes', 'notifications-create']
      );
    } else {
      this.sidebarOptions = this.sidebarController.sidebarOptions();
    }
  }
}
